export const HIRAYS_LOGO = '/images/logo.png'
export const HIRAYS_LOGO_D = '/images/logo.png'
export const HIRAYS_LOGO_H = '/images/logo.png'

/** Slug stubs only — never used as display fallback. Labels come from CMS / i18n. */
export const PRODUCT_NAV = [
  { slug: 'bubble-leak', name: '' },
  { slug: 'airtightness', name: '' },
  { slug: 'gas-detectors', name: '' },
  { slug: 'mass-spectrometers', name: '' },
  { slug: 'helium-leak', name: '' },
  { slug: 'test-platforms', name: '' },
  { slug: 'fixtures', name: '' },
  { slug: 'accessories', name: '' }
]

export const SOLUTION_NAV_IMAGES = {}

export const SOLUTION_NAV_ZH = []
export const APPLICATION_NAV_ZH = []
export const SOLUTION_NAV = []
export const APPLICATION_NAV = []

export const SERVICE_NAV_LINKS = [
  { slug: 'product-support', name: '' },
  { slug: 'value-added', name: '' },
  { slug: 'faq', name: '' }
]

export const ABOUT_NAV_LINKS = [
  { slug: 'company-intro', name: '', hash: 'page1' },
  { slug: 'history', name: '', hash: 'page6' },
  { slug: 'rd', name: '', hash: 'page8' },
  { slug: 'honors', name: '', hash: 'page9' },
  { slug: 'careers', name: '', hash: 'page11' }
]

/** Removed from site; filter CMS nav rows with these slugs */
export const REMOVED_ABOUT_NAV_SLUGS = ['manufacturing', 'gallery', 'culture']

/** No demo product catalog — homepage / nav use CMS only */
export const HOME_PRODUCT_CATEGORIES = []

export const HOME_SOLUTION_SLIDES = []

/* No static banner images — homepage banners come from CMS only. */
export const HOME_BANNER_FALLBACK = []

export const HOME_STATS = []

export const HOME_NEWS_FALLBACK = []
